import PixelModal from "@/components/product/pixel/PixelModal.vue";
import { mapState } from "vuex";
export default {
  components: { PixelModal },
  data() {
    return {
      modal: false,
      loading: false,
      search_text: "",
      editedPixelIndex: null,
      editedPixel: null,
      actions: [
        {
          text: "Editar",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit-pixel"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "fa-regular fa-trash-can",
          confirmation: {
            enable: false
          },
          event: "remove-pixel"
        }
      ]
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    columns() {
      return [
        {
          name: "Pixel",
          field: "code"
        },
        {
          name: "Label de conversão",
          field: "conversion_label"
        },
        {
          name: "",
          type: "menu",
          options: [
            {
              label: "Editar",
              icon: "fa-light fa-pen",
              click: i => this.editPixel(i)
            },
            {
              label: "Excluir pixel",
              class: "text-negative-600",
              icon: "fa-light fa-trash",
              click: i => this.submitRemovePixel(i)
            }
          ]
        }
      ];
    }
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$store
        .dispatch(
          "product/getProduct",
          this.product.id || this.$route.params.id
        )
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    // search(text) {
    //   this.search_text = text;
    // },
    newPixel(type) {
      this.pixelType = type;
      this.modal = true;
    },
    editPixel(item) {
      if (this.product && this.product.pixel) {
        this.editedPixelIndex = item.index;
        this.pixelType = item.type;
        this.editedPixel = item;
        this.modal = true;
      }
    },
    updatePixel(pixel, success_msg, error_msg) {
      this.loading = true;
      this.$store
        .dispatch("product/put", {
          id: this.product.id || this.$route.params.id,
          pixel
        })
        .then(() => {
          this.$message.success(success_msg);
          this.modal = false;
          this.loading = false;
          this.refresh();
        })
        .catch(error => {
          this.loading = false;
          if (error.response && error.response.detail) {
            this.$message.error(error.response.detail);
          } else {
            this.$message.error(error_msg);
          }
        });
    },
    submitRemovePixel({ index }) {
      // use index to remove because the procuders can use two pixels with the same code
      this.updatePixel(
        this.product.pixel.filter((_, idx) => idx !== index),
        "O pixel foi excluído com sucesso.",
        "Não foi possível excluir o pixel!"
      );
    },
    submitEditPixel(pixel) {
      const pixelList = this.product.pixel.map((p, index) =>
        index == this.editedPixelIndex ? pixel : p
      );

      this.updatePixel(
        pixelList,
        "O novo pixel foi atualizado",
        "Não foi possível atualizar as informações pixel"
      );
    },
    submitPixel(pixel) {
      this.updatePixel(
        [...this.product.pixel, pixel],
        "O novo pixel foi adicionado",
        "Não foi possível salvar o novo pixel"
      );
    }
  },
  watch: {
    modal(v) {
      if (!v) {
        this.editedPixelIndex = null;
        this.editedPixel = null;
      }
    }
  }
};
